import { render, staticRenderFns } from "./question-error.vue?vue&type=template&id=d20ca6b0&"
import script from "./question-error.vue?vue&type=script&lang=ts&"
export * from "./question-error.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d20ca6b0')) {
      api.createRecord('d20ca6b0', component.options)
    } else {
      api.reload('d20ca6b0', component.options)
    }
    module.hot.accept("./question-error.vue?vue&type=template&id=d20ca6b0&", function () {
      api.rerender('d20ca6b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/question-error.vue"
export default component.exports